/**
 * Types and constants for deploy code generation
 */

export interface LanguageOption {
    text: string;
    value: string;
}

export interface WorkflowParameter {
    name: string;
    type: string;
    parsed_value: any;
}

export interface WorkflowImage {
    name: string;
}

export const LANGUAGES: LanguageOption[] = [
    { text: "Python", value: "python" },
    { text: "JavaScript Fetch", value: "javascript" },
    { text: "HTTP / cURL", value: "curl" }
];

export const API_KEY_PLACEHOLDER = "**********";

export const BATCH_PROCESSING_CLI_DOCS_LINK =
    "https://inference.roboflow.com/workflows/batch_processing/about/#cli";
